import { gql } from 'apollo-boost';

export const fragments = {
	
	ORGANIZATIONS: {
		QUERY_RETURN:    `id name`,
		MUTATION_RETURN: `id name`,
		EDIT_FIELDS:     `
			id
		    name
		    subscriptionType,
		    organizationMembers{
		        accountId
		        isActive
		        organizationRole
		    }
		`
	}
};

export const queries = {
	
	/* ORGANIZATIONS
	* --------------------------------------------------------------------------------------------*/
	GET_ORGANIZATIONS: ( returnQueryString = fragments.ORGANIZATIONS.QUERY_RETURN ) => gql`
	  query GetOrganizations( $order: [OrganizationSortInput!], $where: OrganizationFilterInput ){
	    organizations( order: $order, where: $where) {
			${ returnQueryString }
		}
	}`,
	
	GET_ORGANIZATION: ( returnQueryString = fragments.ORGANIZATIONS.QUERY_RETURN ) => gql`
	  query GetOrganization( $id: Uuid! ){
	    organizations( where: { id: { eq: $id } } )  {
            ${ returnQueryString }
        }
	}`,
	
};

export const mutations = {
	
	/* ORGANIZATIONS
	* --------------------------------------------------------------------------------------------*/
	CREATE_ORGANIZATION: ( returnQueryString = fragments.ORGANIZATIONS.MUTATION_RETURN ) => gql`
	  mutation CreateProject( $input: OrganizationCreateCommandInput! ){
	    createOrganization( input: $input )  {
	        ${ returnQueryString }
	    }
	  }`,
	
	UPDATE_ORGANIZATION: ( returnQueryString = fragments.ORGANIZATIONS.MUTATION_RETURN ) => gql`
	  mutation UpdateProject( $input: OrganizationUpdateCommandInput! ){
	    updateOrganization( input: $input )  {
	        ${ returnQueryString }
	    }
	  }`,
};

export const OrganizationQueries = {
	fragments,
	queries,
	mutations,
};
